module.exports = __webpack_public_path__ + "static/media/AB_K2_14.fe36cbcd.jpg";